import { connect } from 'react-redux';
import { ImpersonateOrgDialog } from '../components/partials';
import { getImpersonateDialog, getUserData, isUserAdNetwork } from '../selectors/user';
import { closeImpersonateDialog, impersonateDialogStarted, impersonateOrg } from '../actions/user';

const ACCOUNT_STATUS_PENDING = 'PENDING';

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        ...getImpersonateDialog(state),
        isPartnerPending: getUserData(state)?.account_status === ACCOUNT_STATUS_PENDING && isUserAdNetwork(state),
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        onClose: () => {
            dispatch(closeImpersonateDialog());
        },
        onStart: () => {
            dispatch(impersonateDialogStarted());
        },
        onSelection: org => {
            dispatch(impersonateOrg(org));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ImpersonateOrgDialog);
